import { render, staticRenderFns } from "./DocumentContentDropdown.vue?vue&type=template&id=5fec3a2c"
import script from "./DocumentContentDropdown.vue?vue&type=script&lang=js"
export * from "./DocumentContentDropdown.vue?vue&type=script&lang=js"
import style0 from "./DocumentContentDropdown.vue?vue&type=style&index=0&id=5fec3a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports